/**
 * @generated SignedSource<<6ce98281c47b71427424600fff311afa>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ChooseRoleQuery$variables = Record<PropertyKey, never>;
export type ChooseRoleQuery$data = {
  readonly login: {
    readonly availableLoginEntities: ReadonlyArray<{
      readonly __id: string;
      readonly displayName: string | null | undefined;
      readonly loginRole: string;
      readonly loginRoleDescription: string;
    }> | null | undefined;
  } | null | undefined;
};
export type ChooseRoleQuery = {
  response: ChooseRoleQuery$data;
  variables: ChooseRoleQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "loginRole",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "loginRoleDescription",
  "storageKey": null
},
v3 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ChooseRoleQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Login",
        "kind": "LinkedField",
        "name": "login",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "availableLoginEntities",
            "plural": true,
            "selections": [
              (v0/*:: as any*/),
              (v1/*:: as any*/),
              (v2/*:: as any*/),
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ChooseRoleQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Login",
        "kind": "LinkedField",
        "name": "login",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "availableLoginEntities",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v0/*:: as any*/),
              (v1/*:: as any*/),
              (v2/*:: as any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*:: as any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          (v4/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d78f06d6b122e0c376c48e5528e0051f",
    "id": null,
    "metadata": {},
    "name": "ChooseRoleQuery",
    "operationKind": "query",
    "text": "query ChooseRoleQuery {\n  login {\n    availableLoginEntities {\n      __typename\n      displayName\n      loginRole\n      loginRoleDescription\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "9533803116d8e0fd11b4fbb43dd51f5b";

export default node;
